module.exports = __webpack_public_path__ + "static/media/construction.dd062db1.png";